import React from 'react';

import styled from '@emotion/styled';
import {Box, Typography} from '@mui/material';

import makroLoadingGif from 'assets/images/makro-loading.gif';
import theme from 'config/theme';

export const LoadingLabelStyled = styled(Typography)(() => ({
  fontWeight: theme.typography.h1.fontWeight,
  fontSize: theme.typography.h6.fontSize
})) as typeof Typography;

type LoadingProps = {
  loadingMessage?: string;
};

export const Loading: React.FC<LoadingProps> = ({loadingMessage}) => {
  return (
    <Box display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center" padding={25}>
      <img src={makroLoadingGif} alt="Loading" height={48} width={48} />
      <LoadingLabelStyled>{loadingMessage ? loadingMessage : 'Loading...'}</LoadingLabelStyled>
    </Box>
  );
};
